 //是否为正式(生产)环境
 var IS_FORMAL_ENV = false ;   //true是正式坏境，false测试环境
 //请求地址
var DOMAIN = IS_FORMAL_ENV ? "https://shopmall.p8go.cn/" : "https://shopmall.p8go.cn/"; //接口地址
var DOMAIN1 = IS_FORMAL_ENV ? "http://shopmall.p8go.cn/" : "http://shopmall.p8go.cn/"; //访问域名
// var DOMAIN1 = "http://shoppublic.p8go.cn/" ;  //history模式访问域名
module.exports = {
    url :DOMAIN,
    isTest: IS_FORMAL_ENV ? false : true  ,//是否是测试环境
    newUrl:DOMAIN1
}



// WEBPACK FOOTER //
// ./src/api/common.js